<template>
  <div>
    <el-drawer
      title="我是标题"
      :visible.sync="disabled"
      :with-header="false"
      :before-close="close"
      :size="size"
    >
      <div class="head" v-if="disabled">
        <div class="head-l">
          <span>企业</span>
          {{ row.name ? row.name : "暂无" }}
        </div>
        <div class="head-r">
          <button @click="DetailToEdit">编辑</button>
          <!-- <button>更换负责人</button> -->
          <span class="el-icon-refresh-right"></span>
          <span
            v-if="this.model == 2"
            @click="amplification(1)"
            class="el-icon-full-screen"
          ></span>
          <span
            v-if="this.model == 1"
            @click="amplification(2)"
            class="el-icon-aim"
          ></span>
          <span @click="close" class="el-icon-close"></span>
        </div>
      </div>
      <div class="main" v-if="disabled">
        <div class="detailed">
          <div>
            行业类型
            <span>{{ row.TypeInfo.name ? row.TypeInfo.name : "暂无" }}</span>
          </div>
          <div>
            归属代理商
            <span>{{ row.UserInfo.name ? row.UserInfo.name : "暂无" }}</span>
          </div>
          <div>
            防骚扰平台
            <span>{{
              row.BlackPlatInfo.name ? row.BlackPlatInfo.name : "暂无"
            }}</span>
          </div>
          <div>
            风控等级
            <span>{{ row.StormInfo.name ? row.StormInfo.name : "暂无" }}</span>
          </div>
        </div>
        <div class="tab-control">
          <el-tabs v-model="activeName">
            <el-tab-pane label="手机号信息" name="first">
              <MNinformation
                ref="MNinformation"
                :company_id="row.id"
                v-if="activeName == 'first'"
              ></MNinformation>
            </el-tab-pane>
            <el-tab-pane label="坐席信息" name="second">
              <AtTheInformation
                ref="AtTheInformation"
                :company_id="row.id"
                v-if="activeName == 'second'"
              ></AtTheInformation>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AtTheInformation from "./components/AtTheInformation";
import MNinformation from "./components/MNinformation";
export default {
  components: {
    AtTheInformation,
    MNinformation,
  },
  props: {
    rowData: Object,
    isShow: Boolean,
  },
  data() {
    return {
      disabled: this.isShow,
      size: "70%",
      row: {},
      model: 2,
      activeName: "first",
    };
  },

  created() {
    this.row = { ...this.rowData };
  },
  methods: {
    amplification(model) {
      this.model = model;
      if (model == 1) {
        this.size = "100%";
      } else {
        this.size = "70%";
      }
    },
    DetailToEdit() {
      this.$emit("close");
      this.$parent.DetailToEdit();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-drawer {
  height: 100% !important;
}
.head {
  height: 81px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 21px;
  .head-l {
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #333333;
    span {
      margin-right: 10px;
      background-color: #409eff;
      color: white;
      font-size: 12px;
      padding: 5px 17px;
      display: block;
      line-height: 11px;
      border-radius: 2px;
    }
  }
  .head-r {
    button {
      background-color: #f2f4fb;
      color: #333333;
      border: none;
      border-radius: 4px;
      margin-right: 12px;
      padding: 7px 16px;
      font-size: 14px;
    }
    span {
      width: 14px;
      height: 14px;
      margin-right: 19px;
      cursor: pointer;
    }
  }
}
.main {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f3;
  padding: 15px 15px;
  height: 100%;

  .detailed {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      width: 25%;
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-left: 45px;
        color: #333333;
      }
    }
  }
  .tab-control {
    flex: 1;
    background-color: #fff;
    padding: 0px 20px;
    margin-top: 15px;
    /deep/.el-tabs__nav-wrap .is_top {
      height: 50px;
      line-height: 50px;
    }
  }
  /deep/ .is_top .el-tabs__nav-wrap::after {
    height: 1px !important;
  }
}
</style>
